import $ from "jquery";
import Backbone from "backbone";
import Marionette from "backbone.marionette";

import { heapTrack } from "lib/analytics";

import InterviewCard from "./inviteCard";

import modalTemplate from "../templates/components/modal.jst";
import template from "../templates/components/invites.jst";

const Invites = Backbone.Collection.extend({
    url: "/api/v1/invite/",
});

const InvitesView = Marionette.CollectionView.extend({
    childView: InterviewCard,
});

const InviteCards = Marionette.View.extend({
    template,

    ui: {
        cards: ".invite-cards__cards",
        content: ".invite-cards__content",
        count: ".js-count",
        countS: ".js-count-s",
        loader: ".invite-cards__loader",
        skip: ".invite-cards__skip",
    },

    events: {
        "click @ui.skip": "onSkip",
    },

    serializeData() {
        return {
            gender: Math.random() > 0.5 ? "female" : "male",
            showSkip: !!this.options.showSkip,
        };
    },

    onSkip(event) {
        event.preventDefault();

        $.modal.close();
    },

    onAction() {
        this.ui.skip.text("Done");
    },

    onRender() {
        this.collection = new Invites();
        this.collection.fetch().done(() => {
            const view = new InvitesView({
                el: this.ui.cards,
                collection: this.collection,
            });
            this.listenTo(this.collection, "withdraw", this.onAction);
            view.render();

            this.ui.count.text(this.collection.length);
            this.ui.countS.text(this.collection.length > 1 ? "s" : "");

            this.ui.loader.hide();
            this.ui.content.show();
        });

        heapTrack("Invite Cards Shown", {
            isModal: !!this.options.isModal,
            path: window.location.pathname,
        });
    },
});

export default InviteCards;

export const InviteCardsModal = Marionette.View.extend({
    template: modalTemplate,

    ui: {
        content: ".modal-content",
    },

    onRender() {
        this.view = new InviteCards({
            el: this.ui.content,
            showSkip: true,
            isModal: true,
        });
        this.view.render();

        this.$el.addClass("invite-cards__modal");
        this.$el.modal({
            showClose: false,
            escapeClose: false,
            clickClose: false,
            fadeDuration: 100,
            fadeDelay: 0,
        });
    },
});
